import { render } from "./BrowseCategories.vue?vue&type=template&id=d21b0308&scoped=true&ts=true"
import script from "./BrowseCategories.ts?vue&type=script&lang=ts"
export * from "./BrowseCategories.ts?vue&type=script&lang=ts"

import "./BrowseCategories.vue?vue&type=style&index=0&id=d21b0308&scoped=true&lang=scss"

import exportComponent from "D:\\ColorMetal\\cmportal-frontend-master\\cmportal-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d21b0308"]])

export default __exports__